'use client';

import { IconButton } from '@components/button';
import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons';
import useCheckAuth from 'hooks/use-auth-check';
import type { ReactElement } from 'react';
import { validateString } from 'utils/validate-string';

import styles from './preview-toggle.module.scss';

const rootClass = validateString(styles.root);

function PreviewToggle({
  previewEnabled,
}: {
  readonly previewEnabled: boolean;
}): ReactElement | null {
  const authenticated = useCheckAuth();

  if (authenticated === false) {
    return null;
  }

  return (
    <a
      className={rootClass}
      href={previewEnabled ? '/api/exit-preview' : '/api/preview'}
    >
      <IconButton variant="outline">
        {previewEnabled ? <EyeNoneIcon /> : <EyeOpenIcon />}
      </IconButton>
    </a>
  );
}

export default PreviewToggle;
